<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";


export default {
  props: ['appProduct'],
  components: { vueDropzone, validationMessages },

  data() {
    return {
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      productId:'',
      highlighted_image_url: null,
      is_highlighted: 0,
      hasHighlihtedImage:false,
      originalIsHighlighted:null,
      wasSubmited:false,
      dropzoneOptions_highlight: {
        url: "/",
        autoProcessQueue: false,
        addRemoveLinks: false,
        dictRemoveFile: "",
        thumbnailWidth: 500, 
        thumbnailHeight: 700,
        thumbnailMethod: "contain",
        maxFilesize: 2,
        acceptedFiles: "image/*",
        previewTemplate: `
          <div class="dz-preview dz-file-preview">
            <div class="dz-image">
              <img data-dz-thumbnail />
              <div class="button-overlay">
                <button id="custom-add-btn" type="button" class="custom-hover-change custom-border-radius shadow border-1 cursor-pointer btn  bg-white text-black btn-sm d-flex align-items-center justify-content-center gap-1" data-dz-remove>
                <i class="uil uil-edit text-black"></i>
                  <span class="cursor-pointer fw-medium">Change</span>
                </button>
                <button  type="button" class="custom-hover-delete custom-border-radius shadow cursor-pointer btn  bg-white text-danger btn-sm d-flex align-items-center justify-content-center gap-1" data-dz-remove>
                  <i class="uil uil-trash-alt text-danger"></i>
                  <span class="cursor-pointer fw-medium">Delete</span>
                </button>
              </div>
            </div>
          </div>
  `
      },
    };
  },

  validations: {
    highlighted_image_url: { required },
  },

  methods: {
 addMoreFiles() {
      this.$refs.myVueDropzone_image.dropzone.hiddenFileInput.click();
    },
    fileAdded(file) {
      this.hasFiles = true
      console.log('File added:', file)
    },
    fileRemoved(file) {
      // Check if any files remain
      const remainingFiles = this.$refs.myDropzone.dropzone.files.length
      this.hasFiles = remainingFiles > 0
      console.log('File removed:', file)
    },
    removeAllFiles() {
      this.$refs.myDropzone.removeAllFiles()
      this.hasFiles = false
    },

    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      this.showLoader = true;
      let formData = new FormData();

      if(this.is_highlighted !== '')
      formData.append("is_highlighted",this.is_highlighted);
  
      if (this.highlighted_image_url !== '' && this.highlighted_image_url !== null) {
        formData.append("image_highlighted_url", this.highlighted_image_url);
      } else {
        formData.append("image_highlighted_url", ""); 
      }

      formData.append("_method","PATCH")

      
      try {
        const response = await Merchandising.editAppProduct(formData,this.productId); 
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to edit product. Please try again.", "error");
          this.refreshData();
        } else {
          Swal.fire("Success", "Product edited successfully!", "success");
          this.wasSubmited = true;
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to edit product:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to edit products. Please try again.", "error");
        this.refreshData();
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },


    resetForm() {
     
      this.highlighted_image_url = null;
      this.is_highlighted = 0;
      this.submitted = false;
      this.tryingToSubmit = false;
      this.hasHighlihtedImage = false;
      this.$v.$reset();
      

      if (this.$refs.myVueDropzone_highlight) {
        this.$refs.myVueDropzone_highlight.removeAllFiles();
      }
    },

    closeModal() {
      if(!this.wasSubmited){
        this.is_highlighted = this.originalIsHighlighted;
      }
      this.wasSubmited = false;

      this.resetForm();
      this.showModal = false;
    },


    removeHighlightedImage() {
      this.highlighted_image_url = null;
      this.hasHighlihtedImage = false;
    },

  

    selectHighlightUrl(files) {
      setTimeout(() => {
        let queuedFiles2 = this.$refs.myVueDropzone_highlight.getQueuedFiles();
        if (queuedFiles2.length > 1) {
          this.failedmsg('You can only have one large image')

          files.forEach((value) => {
            this.$refs.myVueDropzone_highlight.removeFile(value)
          });
        }

        this.highlighted_image_url = queuedFiles2[0];
      }, 250);
    },


    syncData() {
      this.productId= this.appProduct.id;
      this.originalIsHighlighted = this.appProduct.is_highlighted;

      this.is_highlighted = this.appProduct.is_highlighted
      
      this.highlighted_image_url = this.appProduct.image_highlighted_url;
      if(this.highlighted_image_url !== null && this.highlighted_image_url !== ''){
        this.hasHighlihtedImage = true;
      }
    },

    refreshData() {
      this.$emit("onRefresh");
    },
  },
};
</script>

<template>
  <b-modal @shown="syncData" @hidden="resetForm" id="add_app_product_highlight" size="md" v-model="showModal"
    title="Edit App Product" title-class="font-18">
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <div class="row">
              <div class="col-12">
                <b-form-group>
                 <label class="mb-3 fw-medium">Product Image</label>
                  <div v-if="hasHighlihtedImage" class="d-flex flex-column align-items-center justify-content-center gap-2 mb-2">
                     <img :src="highlighted_image_url" style="width:500px;" />
                     <i class="cursor-pointer uil uil-trash-alt font-size-18 text-danger" @click="removeHighlightedImage()"></i>
                  </div>

                  <vue-dropzone
                       v-else
                       ref="myVueDropzone_highlight"
                       class="d-flex align-items-center justify-content-center p-0"
                       id="product-image-dropzone"
                      :options="dropzoneOptions_highlight"
                       @vdropzone-files-added="selectHighlightUrl"
                       :useCustomSlot=true
                      >
                      <div class="dropzone-custom-content">
                      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-upload w-12 h-12 custom-color-gray-400 mb-4">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="17 8 12 3 7 8"></polyline>
                        <line x1="12" x2="12" y1="3" y2="15"></line>
                      </svg>
                      <h3 class="dropzone-custom-title custom-color-gray-400 font-size-16">Drop files here to upload
                      </h3>
                      <div class="subtitle custom-color-gray-400 font-size-16">or click to browse</div>
                    </div>
                    </vue-dropzone>
                       <validationMessages v-if="submitted" :fieldName="'Highlighted Image'" :validationName="$v.highlighted_image_url">
                  </validationMessages>
                </b-form-group>
              </div>
            </div>
          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" class="text-dark" @click="closeModal">Close</b-button>
      <b-button variant="primary" class="btn-dark" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
<style>
#product-image-dropzone .dz-preview .dz-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#product-image-dropzone .dz-preview .dz-image img {
  object-fit: contain;
  /* Ensures the image scales without cropping */
  max-width: 100%;
  max-height: 100%;
}

#product-highlighted-image-dropzone .dz-preview .dz-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#product-highlighted-image-dropzone.dz-preview .dz-image img {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}





/* Remove ALL hover effects */
#product-image-dropzone .dz-preview:hover .dz-image img {
  filter: none !important;
  transform: none !important;
  opacity: 1 !important;
}

#product-image-dropzone .dz-preview .dz-image::before,
#product-image-dropzone .dz-preview .dz-image::after {
  display: none !important;
  content: none !important;
}

#product-image-dropzone .dz-preview:hover {
  opacity: 1 !important;
  background: none !important;
}

#product-image-dropzone .dz-preview:hover .dz-details {
  opacity: 1 !important;
  background: none !important;
}

#product-image-dropzone .dz-preview .dz-details {
  opacity: 1 !important;
  position: relative !important;
  background: none !important;
}

/* Remove the semi-transparent overlay on hover */
#product-image-dropzone .dz-preview .dz-image {
  position: relative !important;
}

#product-image-dropzone .dz-preview:hover .dz-image {
  background: none !important;
}

/* Disable all transitions */
#product-image-dropzone .dz-preview * {
  transition: none !important;
}

#product-image-dropzone .dz-preview .dz-progress,
#product-image-dropzone .dz-preview .dz-success-mark,
#product-image-dropzone .dz-preview .dz-error-mark {
  display: none !important;
}

/* Make preview full width */
#product-image-dropzone .dz-preview {
  width: 100% !important;
  margin: 0 !important;
}

#product-image-dropzone .dz-preview .dz-image {
  width: 100% !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative !important;
}

#product-image-dropzone .dz-preview .dz-image img {
  object-fit: contain;
  max-width: 100%;
  height: auto;
  width: 100%;
}
</style>
